export default "__VITE_PUBLIC_ASSET__ba2f3c95__"